import React, { useState } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { SelectInput } from "../reusable/SelectInput";
import { TextInput } from "../reusable/TextInput";
import InputLabel from "@material-ui/core/InputLabel";
import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import { statusOptions } from "../utils/helper";

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    height: "100%",
    width: "100%",
    overflow: "hidden",
    border: "1px solid #eee",
    borderRadius: 10,
  },
  table: {
    "& th": {
      whiteSpace: "nowrap",
      textAlign: "center",
      width: 200,
      color: "#fff",
      background: "#335fd4",
    },
    "& td": {
      whiteSpace: "nowrap",
      width: 200,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& tr": {
      "&:nth-child(even)": {
        "& td": {
          background: "#f5f7f8",
        },
      },
    },
  },
  dialog: {
    width: "100%",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dialogContent: {
    width: 600,
    padding: 20,
    boxSizing: "border-box",
    borderTop: "1px solid #eee",
    borderBottom: "1px solid #eee",
  },
  agentList: {
    padding: 0,
    listStyle: "none",
    margin: 0,
    "& li": {
      padding: "5px 0",
      display: "flex",
      alignItems: "center",
      "& h6": {
        width: 200,
        fontWeight: "bold",
      },
    },
  },
  dialogActions: {
    padding: "10px 20px",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  proofContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "& img": {
      margin: "0 20px 0 0",
    },
    "& a": {
      color: "#141414",
    },
  },
  formControl: {
    width: 200,
  },
  proofWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "#fff",
    zIndex: 5,
    transform: "scale(0)",
    transition: "0.5s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  closeProof: {
    color: "#000",
    position: "absolute",
    top: 0,
    right: 10,
    zIndex: 6,
  },
  maxActive: {
    transform: "scale(1) !important",
  },
  proofContent: {
    "& img": {
      width: "100%",
      height: "100%",
    },
  },
}));

export const DialogDetail = ({ selectedRow, handleClose, open }) => {
  const classes = useStyles();
  const [maximize, setMaximize] = useState(false);
  const [selectedImg, setSelectedImage] = useState();
  const [state, setState] = useState({
    status: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  const download = (e, href) => {
    e.preventDefault();
    fetch(href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "image.png"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Dialog
      className={classes.dialog}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.dialogTitle}>
        <DialogTitle>Doctor Details</DialogTitle>
        <IconButton
          onClick={() => handleClose()}
          aria-label="close"
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.dialogContent}>
        <ul className={classes.agentList}>
          <li>
            <Typography component="h6">Email:</Typography>
            <Typography component="p">{selectedRow?.emailAddress}</Typography>
          </li>
          <li>
            <Typography component="h6">Account Number:</Typography>
            <Typography component="p">{selectedRow?.accountNumber}</Typography>
          </li>
          <li>
            <Typography component="h6">Bank Branch Name:</Typography>
            <Typography component="p">{selectedRow?.bankBranch}</Typography>
          </li>
          <li>
            <Typography component="h6">Address:</Typography>
            <Typography component="p">{selectedRow?.address}</Typography>
          </li>
          <li>
            <Typography component="h6">Address Proof:</Typography>
            <Typography component="p">{selectedRow?.addressProof}</Typography>
          </li>
          <li>
            <Typography component="h6">Certifications:</Typography>
            <Typography component="p">{selectedRow?.awards}</Typography>
          </li>
          <li>
            <Typography component="h6">Bank Account Number:</Typography>
            <Typography component="p">{selectedRow?.accountNumber}</Typography>
          </li>
          <li>
            <Typography component="h6">City:</Typography>
            <Typography component="p">{selectedRow?.city}</Typography>
          </li>
          <li>
            <Typography component="h6">Clinic:</Typography>
            <Typography component="p">{selectedRow?.HospitalName}</Typography>
          </li>
          <li>
            <Typography component="h6">Consult Type:</Typography>
            <Typography component="p">{selectedRow?.consultType}</Typography>
          </li>
          <li>
            <Typography component="h6">Country:</Typography>
            <Typography component="p">{selectedRow?.country}</Typography>
          </li>
          <li>
            <Typography component="h6">Education:</Typography>
            <Typography component="p">{selectedRow?.education}</Typography>
          </li>
          <li>
            <Typography component="h6">Experience</Typography>
            <Typography component="p">{selectedRow?.experience}</Typography>
          </li>
          <li>
            <Typography component="h6">First Name</Typography>
            <Typography component="p">{selectedRow?.firstName}</Typography>
          </li>
          <li>
            <Typography component="h6">Gender:</Typography>
            <Typography component="p">{selectedRow?.gender}</Typography>
          </li>
          <li>
            <Typography component="h6">IFSC Code:</Typography>
            <Typography component="p">{selectedRow?.ifscCode}</Typography>
          </li>
          <li>
            <Typography component="h6">Known Languages:</Typography>
            <Typography component="p">{selectedRow?.languages}</Typography>
          </li>
          <li>
            <Typography component="h6">Last Name:</Typography>
            <Typography component="p">{selectedRow?.lastName}</Typography>
          </li>
          <li>
            <Typography component="h6">Location:</Typography>
            <Typography component="p">{selectedRow?.locationName}</Typography>
          </li>
          <li>
            <Typography component="h6">MCI Number:</Typography>
            <Typography component="p">{selectedRow?.mciNumber}</Typography>
          </li>
          <li>
            <Typography component="h6">Middle Name:</Typography>
            <Typography component="p">{selectedRow?.middleName}</Typography>
          </li>
          <li>
            <Typography component="h6">Name As Per Bank:</Typography>
            <Typography component="p">{selectedRow?.bankRecordName}</Typography>
          </li>
          <li>
            <Typography component="h6">Online Fees:</Typography>
            <Typography component="p">
              {selectedRow?.onlineConsultationFees}
            </Typography>
          </li>
          <li>
            <Typography component="h6">Phone Number:</Typography>
            <Typography component="p">{selectedRow?.mobileNumber}</Typography>
          </li>
          <li>
            <Typography component="h6">Alernate Phone Number 1:</Typography>
            <Typography component="p">{selectedRow?.alternatePhone}</Typography>
          </li>
          <li>
            <Typography component="h6">Alernate Phone Number 2:</Typography>
            <Typography component="p">
              {selectedRow?.alternatePhoneTwo}
            </Typography>
          </li>
          <li>
            <Typography component="h6">Physical Fees:</Typography>
            <Typography component="p">
              {selectedRow?.physicalConsultationFees}
            </Typography>
          </li>
          <li>
            <Typography component="h6">Pincode:</Typography>
            <Typography component="p">{selectedRow?.pinCode}</Typography>
          </li>
          {/* <li>
                    <Typography component="h6">Representative Name:</Typography>
                    <Typography component="p">{selectedRow.repName}</Typography>
                </li> */}
          <li>
            <Typography component="h6">Secretary Name:</Typography>
            <Typography component="p">{selectedRow?.secretaryName}</Typography>
          </li>
          <li>
            <Typography component="h6">Secretary Number:</Typography>
            <Typography component="p">{selectedRow?.secretaryNo}</Typography>
          </li>
          <li>
            <Typography component="h6">Specialty:</Typography>
            <Typography component="p">{selectedRow?.specialty}</Typography>
          </li>
          <li>
            <Typography component="h6">State:</Typography>
            <Typography component="p">{selectedRow?.state}</Typography>
          </li>
          <li>
            <Typography component="h6">Pan Card:</Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.panCard}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.panCard);
                }}
              />
              <a
                href={selectedRow?.panCard}
                download
                onClick={(e) => {
                  e.preventDefault()
                  download(e, selectedRow?.panCard)
                }}
              >
                <GetAppIcon />
              </a>
            </div>
          </li>
          <li>
            <Typography component="h6">Profile Picture:</Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.profilePicture}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.profilePicture);
                }}
              />
              <a
                href={selectedRow?.profilePicture}
                download
                onClick={(e) => download(e, selectedRow?.profilePicture)}
              >
                <GetAppIcon />
              </a>
            </div>
          </li>
         
       
          <li>
            <Typography component="h6">Registration Certificate:</Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.registrationCertificate}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.registrationCertificate);
                }}
              />
              <a
                href={selectedRow?.registrationCertificate}
                download
                onClick={(e) =>
                  download(e, selectedRow?.registrationCertificate)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

         
          <li>
            <Typography component="h6">Cancel Check</Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.cancel_check}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.cancel_check);
                }}
              />
              <a
                href={selectedRow?.cancel_check}
                download
                onClick={(e) =>
                  download(e, selectedRow?.cancel_check)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

          

           <li>
            <Typography component="h6">BTech Education Proof: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.btech_education_proof}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.btech_education_proof);
                }}
              />
              <a
                href={selectedRow?.btech_education_proof}
                download
                onClick={(e) =>
                  download(e, selectedRow?.btech_education_proof)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

      <li>
            <Typography component="h6">Phd Education Proof: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.phd_education_proof}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.phd_education_proof);
                }}
              />
              <a
                href={selectedRow?.phd_education_proof}
                download
                onClick={(e) =>
                  download(e, selectedRow?.phd_education_proof)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

<li>
            <Typography component="h6">Diploma Education Proof: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.diploma_education_proof}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.diploma_education_proof);
                }}
              />
              <a
                href={selectedRow?.diploma_education_proof}
                download
                onClick={(e) =>
                  download(e, selectedRow?.diploma_education_proof)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>
<li>
            <Typography component="h6">Dnb Certificate: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.dnb_certificate}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.dnb_certificate);
                }}
              />  
              <a
                href={selectedRow?.dnb_certificate}
                download
                onClick={(e) =>
                  download(e, selectedRow?.dnb_certificate)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

      <li>
            <Typography component="h6">Speciality Certificate: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.speciality_certificate}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.speciality_certificate);
                }}
              />  
              <a
                href={selectedRow?.speciality_certificate}
                download
                onClick={(e) =>
                  download(e, selectedRow?.speciality_certificate)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

        <li>
            <Typography component="h6">Fellowship Certificate: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.fellowship_certificate}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.fellowship_certificate);
                }}
              />  
              <a
                href={selectedRow?.fellowship_certificate}
                download
                onClick={(e) =>
                  download(e, selectedRow?.fellowship_certificate)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>



          <li>
            <Typography component="h6">Membership: </Typography>
            <Typography component="p">{selectedRow?.membership}</Typography>
          </li>


        <li>
            <Typography component="h6">Conditions & Procedure: </Typography>
            <Typography component="p">{selectedRow?.conditions_procedure}</Typography>
          </li>


        <li>
            <Typography component="h6">Services Offered: </Typography>
            <Typography component="p">{selectedRow?.services_offered}</Typography>
          </li>


        <li>
            <Typography component="h6">Publication Link: </Typography>
            <Typography component="p">{selectedRow?.publication_link}</Typography>
          </li>

        <li>
            <Typography component="h6">Adhar Backside: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.adhar_backside}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.adhar_backside);
                }}
              />  
              <a
                href={selectedRow?.adhar_backside}
                download
                onClick={(e) =>
                  download(e, selectedRow?.adhar_backside)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

          <li>
            <Typography component="h6">Canceled Check: </Typography>
            <div
              className={classes.proofContainer}
            >
              <img
                style={{ width: 20, height: 20 }}
                src={`${selectedRow?.cancel_check}`}
                onClick={() => {
                  setMaximize(true);
                  setSelectedImage(selectedRow?.cancel_check);
                }}
              />  
              <a
                href={selectedRow?.cancel_check}
                download
                onClick={(e) =>
                  download(e, selectedRow?.cancel_check)
                }
              >
                <GetAppIcon />
              </a>
            </div>
          </li>

          {selectedRow?.status !== "approved" && (
            <li>
              <Typography component="h6">Status:</Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <SelectInput
                  name="status"
                  label={"Status"}
                  options={statusOptions}
                  onChange={handleChange}
                />
              </FormControl>
            </li>
          )}
          {state.status === "rejected" && (
            <li>
              <Typography component="h6">Reason:</Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <TextInput
                  name="reason"
                  label={"Reason"}
                  onChange={handleChange}
                />
              </FormControl>
            </li>
          )}
        </ul>

        <div
          className={`${classes.proofWrapper} ${
            maximize ? classes.maxActive : ""
          }`}
        >
          <IconButton
            onClick={() => setMaximize(false)}
            aria-label="close"
            className={classes.closeProof}
          >
            <CloseIcon />
          </IconButton>
          <div className={classes.proofContent}>
            <img src={`${selectedImg}`} />
          </div>
        </div>
      </DialogContent>
      {selectedRow?.status !== "approved" && (
        <DialogActions className={classes.dialogActions}>
          <Button
            autoFocus
            variant="contained"
            onClick={() => handleClose(state)}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};
